import { makeEntityScaffold } from '@classpass/saga-tools';

const FILTERS_TIMEOUT = 5000; // Default timeout for Filters API, as a temporary measure while core cause for timeouts is investigated.

export const filtersByHash = makeEntityScaffold(
  'SAGA.API.FILTERS_BY_HASH',
  (client, hash, overrides) =>
    client.filters
      .getByHash(hash, null, { timeout: FILTERS_TIMEOUT, ...overrides }) // has URL params, second argument is query params, third is overrides.
      .then(data => data.data),
  { defaultKey: 1 }
);

export const filtersByQuery = makeEntityScaffold('SAGA.API.FILTERS_BY_QUERY', (client, params, overrides) =>
  client.filters
    .getByQuery(params, { timeout: FILTERS_TIMEOUT, ...overrides }) // has no URL params, second argument is overrides.
    .then(data => data.data)
);

export const relatedFiltersByHash = makeEntityScaffold(
  'SAGA.API.RELATED_FILTERS_BY_HASH',
  (client, hash, overrides) =>
    client.filters
      .getRelatedByHash(hash, null, { timeout: FILTERS_TIMEOUT, ...overrides })
      .then(data => data.data)
      .then(data => data.groups)
      .then(groups => groups.filter(group => group.filters && group.filters.length)),
  { defaultKey: 1 }
);
